<template>
  <div class="rectangular-stencil" :style="style">
    <draggable-area @move="onMove" @move-end="onMoveEnd">
      <stencil-preview
        class="rectangular-stencil__preview"
        :image="image"
        :coordinates="coordinates"
        :width="stencilCoordinates.width"
        :height="stencilCoordinates.height"
        :transitions="transitions"
        :aspect-ratio="aspectRatio"
      />
    </draggable-area>
  </div>
</template>

<script>
import { DraggableArea, StencilPreview } from "vue-advanced-cropper";

export default {
  components: {
    StencilPreview,
    DraggableArea,
  },
  props: {
    image: {
      type: Object,
    },
    coordinates: {
      type: Object,
    },
    transitions: {
      type: Object,
    },
    stencilCoordinates: {
      type: Object,
    },
    aspectRatio: {
      type: Number,
      default: 2.5, // Default aspect ratio is 2.5
    },
  },
  computed: {
    style() {
      const { height, width, left, top } = this.stencilCoordinates;
      const style = {
        width: `${width}px`,
        height: `${height}px`,
        transform: `translate(${left}px, ${top}px)`,
      };
      if (this.transitions && this.transitions.enabled) {
        style.transition = `${this.transitions.time}ms ${this.transitions.timingFunction}`;
      }
      return style;
    },
  },
  methods: {
    onMove(moveEvent) {
      this.$emit("move", moveEvent);
    },
    onMoveEnd() {
      this.$emit("move-end");
    },
    aspectRatios() {
      return {
        minimum: this.aspectRatio || 2.5, // Use the aspectRatio prop or default to 2.5
        maximum: this.aspectRatio || 2.5,
      };
    },
  },
};
</script>

<style lang="scss">
.rectangular-stencil {
  cursor: move;
  position: absolute;
  border: dashed 2px white;
  box-sizing: border-box;
  &__handler {
    position: absolute;
    right: 15%;
    top: 14%;
    z-index: 1;
    cursor: ne-resize;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: translate(50%, -50%);
  }
  &__preview {
    overflow: hidden;
  }
}
</style>
